<div class="ziti-page-container ziti-sessions-container">
  <lib-list-page-header [title]="title"
    [tabs]="tabs"
    [hideAction]="true"
    [blockCreate]="headerBlockCreate"
    [blockDelete]="headerBlockDelete"
  (actionClicked)="headerActionClicked($event)"></lib-list-page-header>

  <lib-data-table [tableId]="'sessions'"
    [noItemsReadonly]="headerBlockCreate"
    [accessDenied]="headerBlockRead"
    [rowData]="rowData"
    [isLoading]="isLoading"
    [columnDefinitions]="columnDefs"
    (actionRequested)="tableAction($event)"
    [startCount]="startCount"
    [endCount]="endCount"
    [totalCount]="totalCount"
    [emptyMsg]="'No Sessions defined'"
    [filterApplied]="filterApplied"
    [filterColumn]="'id'"
    [filterName]="'id'"
    [menuItems]="svc.menuItems"
    [showNoItemsAdd]="false"
    (gridReady)="gridReady($event)"
    >
  </lib-data-table>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
